import { render, staticRenderFns } from "./BoxItemCanje.vue?vue&type=template&id=70fc8408&"
import script from "./BoxItemCanje.vue?vue&type=script&lang=js&"
export * from "./BoxItemCanje.vue?vue&type=script&lang=js&"
import style0 from "./BoxItemCanje.vue?vue&type=style&index=0&id=70fc8408&prod&lang=css&"
import style1 from "./BoxItemCanje.vue?vue&type=style&index=1&id=70fc8408&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports